import { default as GallectionDeviationManager } from './GallectionDeviationManager';

export default GallectionDeviationManager;
